import { render, staticRenderFns } from "./Company_informations.vue?vue&type=template&id=441a8a1d&scoped=true&lang=pug&"
import script from "./Company_informations.vue?vue&type=script&lang=coffee&"
export * from "./Company_informations.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441a8a1d",
  null
  
)

export default component.exports